import { render, staticRenderFns } from "./AddTrackForm.vue?vue&type=template&id=3d967e68&scoped=true"
import script from "./AddTrackForm.vue?vue&type=script&lang=js"
export * from "./AddTrackForm.vue?vue&type=script&lang=js"
import style0 from "./AddTrackForm.vue?vue&type=style&index=0&id=3d967e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d967e68",
  null
  
)

export default component.exports